"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Parser = exports.parse = void 0;
var tslib_1 = require("tslib");
function parse() {
    throw new Error("You're trying to format an uncompiled message with react-intl without parser, please import from 'react-int' instead");
}
exports.parse = parse;
tslib_1.__exportStar(require("./types"), exports);
exports._Parser = undefined;
